


const CitiInner = () => {
    return (
        <>
            <h2 className="text-hbku-primary">How to Access CITI Training</h2>
            <div className="accordion-wrap mt-5 mb-5">

                <div className="l-article l-accordion l-accordion4 p-0">
                    <div className="mez slider">
                        <h3 className="l-accordion__title">
                            <span>Step 1: Create or Access Your CITI Account</span>
                        </h3>
                        <div className="l-accordion__content text">
                            <p className='fs-18'>
                                <strong>A.</strong> Visit the  <a className="text-primary" href="https://about.citiprogram.org/" target="_blank" rel="noopener noreferrer"><strong>Research, Ethics, Compliance, and Safety Training</strong></a>  page and access the CITI platform.
                            </p>
                            <p className='fs-18'><strong>B.</strong> CITI may ask whether you have an existing account with different credentials that you would like to merge.</p>


                            <ul className="mb-4">
                                <li>Select <strong>“No”</strong> if you are not aware of another CITI profile.</li>
                                <li>Select <strong>“Yes”</strong> if you already have another CITI profile. You will then be prompted to provide additional details to merge your accounts.</li>

                            </ul>
                            <p className='fs-18'><strong>C.</strong> CITI may ask whether you have an existing account with different credentials that you would like to merge.</p>

                            <p className='fs-18'><strong>D.</strong> New users will be asked to complete additional profile questions, including general information and demographics.</p>
                        </div>

                        <h3 className="l-accordion__title">
                            <span>Step 2: Enroll in the Appropriate Course</span>
                        </h3>
                        <div className="l-accordion__content text">
                            <p className='fs-18 mb-0'><strong>A. New CITI Users</strong> </p>
                            <p className='fs-18'>You will automatically be directed to the <strong>“Select Curriculum”</strong> questionnaire as part of the account setup.</p>
                            <p className='fs-18 mb-0'><strong>B. Existing CITI Users</strong> </p>
                            <p className='fs-18'>You may see different screens. To locate or enroll in your courses:</p>
                            <ol className="mb-4 ps-5">
                                <li>Click “My Courses” at the top of the page after logging in.</li>
                                <li>If the Institutional Courses page appears, click <strong>“View Courses”</strong> next to HBKU</li>
                                <li>If an appropriate RCR or COI course appears under <strong>“Active Courses”</strong>  or <strong>“Courses Ready to Begin”</strong>, select it to start the modules.</li>
                                <li>If you do not see the required RCR or COI course, scroll down to <strong>“Learner Tools for HBKU”</strong> and click <strong>“Add a Course.”</strong></li>
                               
                            </ol>
                            </div>
                            <h3 className="l-accordion__title">
                                <span>Step 3: Select the <strong>Correct Curriculum</strong></span>
                            </h3>
                            <div className="l-accordion__content text">
                                <p className='fs-18'>On the “Select Curriculum” questionnaire:</p>
                                <ul className="mb-4">
                                    <li>You may skip most questions (leave blank or select <strong>“Not at this time”</strong>) except Question 5 and 10 unless specific guidance is provided.</li>
                                    <li>Ensure any required questions are completed as prompted by the system.</li>
                                </ul>
                            </div>
                        
                         <h3 className="l-accordion__title">
                            <span>Step 4: Complete the course</span>
                        </h3>
                        <div className="l-accordion__content text">
                             <ul className="mb-4">
                                    <li>A list of available courses will appear. You may ignore COVID-19-related courses unless instructed otherwise. </li>
                                    <li>Complete "RCR Basic Course" or "COI course" by clicking "Start Now" or complete</li>
                                </ul>
                        </div>



                    </div>
                </div>
            </div>

        </>


    )
}
export default CitiInner